import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CollapseBlock } from '../../../../common/index.jsx';
import DeansOfficeTable from './DeansOfficeTable.jsx';
import { CellLayout } from '../../../../common/index.jsx';
import {
  DEPARTMENT_FUNCTION_DEAN,
  DEPARTMENT_FUNCTION_ECONOMIC_OFFICE,
  DEPARTMENT_FUNCTION_FACULTY_SECRETARY,
  DEPARTMENT_FUNCTION_LABEL_DEAN,
  DEPARTMENT_FUNCTION_LABEL_ECONOMIC_OFFICE,
  DEPARTMENT_FUNCTION_LABEL_FACULTY_SECRETARY,
  DEPARTMENT_FUNCTION_LABEL_PHD_AND_CAREER_OFFICE,
  DEPARTMENT_FUNCTION_LABEL_PERSONNEL_OFFICE,
  DEPARTMENT_FUNCTION_LABEL_PROJECTS_AND_RELATIONS_OFFICE,
  DEPARTMENT_FUNCTION_LABEL_STUDY_OFFICE,
  DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_EDUCATION,
  DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_INTERNATIONAL,
  DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_SCIENCE,
  DEPARTMENT_FUNCTION_PHD_AND_CAREER_OFFICE,
  DEPARTMENT_FUNCTION_PERSONNEL_OFFICE,
  DEPARTMENT_FUNCTION_PROJECTS_AND_RELATIONS_OFFICE,
  DEPARTMENT_FUNCTION_STUDY_OFFICE,
  DEPARTMENT_FUNCTION_VICE_DEAN_EDUCATION,
  DEPARTMENT_FUNCTION_VICE_DEAN_INTERNATIONAL,
  DEPARTMENT_FUNCTION_VICE_DEAN_SCIENCE,
  ROLE_DEPARTMENT_SECRETARY,
} from '../../../../../utils/constants/roles.js';

export default function DeansOfficeGeneralInformation({ department }) {
  const { t } = useTranslation();

  const getEmployee = useCallback(
    (position) => department.mapped_functions?.[position] ?? null,
    [department],
  );

  return (
    <CollapseBlock title={t('Všeobecné informácie')} collapsible collapse>
      <CellLayout layout="two-cells">
        <CellLayout.Cell>{t('Adresa')}</CellLayout.Cell>
        <CellLayout.Cell>{department?.address}</CellLayout.Cell>
      </CellLayout>
      <CellLayout layout="two-cells">
        <CellLayout.Cell>{t('Telefón')}</CellLayout.Cell>
        <CellLayout.Cell>{department?.phone}</CellLayout.Cell>
      </CellLayout>

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_DEAN)}
        position={t(DEPARTMENT_FUNCTION_LABEL_DEAN)}
      />
      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_VICE_DEAN_SCIENCE)}
        position={t(DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_SCIENCE)}
      />

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_VICE_DEAN_EDUCATION)}
        position={t(DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_EDUCATION)}
      />

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_VICE_DEAN_INTERNATIONAL)}
        position={t(DEPARTMENT_FUNCTION_LABEL_VICE_DEAN_INTERNATIONAL)}
      />

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_FACULTY_SECRETARY)}
        position={t(DEPARTMENT_FUNCTION_LABEL_FACULTY_SECRETARY)}
      />

      <DeansOfficeTable
        modelArray={getEmployee(ROLE_DEPARTMENT_SECRETARY)}
        position={t('Sekretariát')}
        note={
          <>
            {t('Zastupuje')} <strong>Ing. Jana Sobola Stranianková</strong>
          </>
        }
      />

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_PHD_AND_CAREER_OFFICE)}
        position={t(DEPARTMENT_FUNCTION_LABEL_PHD_AND_CAREER_OFFICE)}
      />

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_PERSONNEL_OFFICE)}
        position={t(DEPARTMENT_FUNCTION_LABEL_PERSONNEL_OFFICE)}
      />

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_STUDY_OFFICE)}
        position={t(DEPARTMENT_FUNCTION_LABEL_STUDY_OFFICE)}
      />

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_ECONOMIC_OFFICE)}
        position={t(DEPARTMENT_FUNCTION_LABEL_ECONOMIC_OFFICE)}
      />

      <DeansOfficeTable
        modelArray={getEmployee(DEPARTMENT_FUNCTION_PROJECTS_AND_RELATIONS_OFFICE)}
        position={t(DEPARTMENT_FUNCTION_LABEL_PROJECTS_AND_RELATIONS_OFFICE)}
      />
    </CollapseBlock>
  );
}
